import ToolToggleBlock from './ToolToggleBlock';

class ToolToggleHeading4 extends ToolToggleBlock {
  static toolName = 'Heading 4';
  static iconClass = 'fa-regular fa-h4';
  static blockType = 'h4';
  static shortcut = 'Cmd+Option+4';
}

export default ToolToggleHeading4;
